import { QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";

import { AuthGuard } from "@/components/layout/AuthGuard";
import { ErrorBoundary } from "@/components/layout/ErrorBoundary";
import { Header } from "@/components/layout/Header";
import { MobileBottomNav } from "@/components/layout/MobileBottomNav";
import { queryClient } from "@/config/query-client";
import { AuthProvider } from "@/contexts/auth-context";
import { Achievements } from "@/pages/Achievements";
import { AuthCallback } from "@/pages/AuthCallback";
import { ChallengePlay } from "@/pages/ChallengePlay";
import { Challenges } from "@/pages/Challenges";
import { Home } from "@/pages/Home";
import { Leaderboard } from "@/pages/Leaderboard";
import { Login } from "@/pages/Login";
import { Play } from "@/pages/Play";
import { Profile } from "@/pages/Profile";
import { Progress } from "@/pages/Progress";
import { Review } from "@/pages/Review";
import { Stats } from "@/pages/Stats";

function RootLayout() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

function AuthenticatedLayout() {
  return (
    <AuthGuard>
      <div className="flex min-h-screen flex-col">
        <Header />
        <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-6 pb-20 md:pb-6">
          <Outlet />
        </main>
        <MobileBottomNav />
      </div>
    </AuthGuard>
  );
}

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: "login", element: <Login /> },
      { path: "auth/callback", element: <AuthCallback /> },
      {
        element: <AuthenticatedLayout />,
        children: [
          { index: true, element: <Home /> },
          { path: "play", element: <Play /> },
          { path: "progress", element: <Progress /> },
          { path: "review/:scenarioId", element: <Review /> },
          { path: "stats", element: <Stats /> },
          { path: "leaderboard", element: <Leaderboard /> },
          { path: "achievements", element: <Achievements /> },
          { path: "challenges", element: <Challenges /> },
          { path: "challenge/:challengeId", element: <ChallengePlay /> },
          { path: "profile", element: <Profile /> },
        ],
      },
    ],
  },
]);

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
